import axios from 'axios'

export default axios.create({
  baseURL: process.env.VUE_APP_HUMANIOUS_BASE_URL,
  timeout: 60 * 1000 * 10
})
